var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.noProgressFor > 7)?_c('span',[_c('feather-icon',{attrs:{"icon":"AlertTriangleIcon","svgClasses":"h-3 w-3"}}),_vm._v("\n    no progress for "+_vm._s(_vm.noProgressFor)+" days\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }